import React from "react";

const LoadingOverlay = () => {
  return (
    <div className="loading-overlay">
      <div className="loader"></div>
    </div>
  );
};

export default LoadingOverlay;

export const PageLoader = () => {
  return (
    <div className="loading-page">
      <div className="loader"></div>
    </div>
  );
};
